import React, { useState, useEffect, useCallback } from 'react';
import Layout from '@/components/Layout';
import { Button } from '@/components/ui/button';
import { Plus, ChevronRight, Play } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ElearningActivitiesPage = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActivities = useCallback(async () => {
    try {
      const coursesRes = await fetch(`${API}/courses/?published_only=false`, { credentials: 'include' });
      const allActivities = [];
      if (coursesRes.ok) {
        const courses = await coursesRes.json();
        for (const course of courses) {
          const qRes = await fetch(`${API}/quizzes/course/${course.course_id}`, { credentials: 'include' });
          if (qRes.ok) {
            const quizzes = await qRes.json();
            quizzes.forEach(q => {
              allActivities.push({ id: q.quiz_id, title: q.title, type: 'quiz', course_title: course.title });
            });
          }
        }
      }
      setActivities(allActivities);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchActivities(); }, [fetchActivities]);

  return (
    <Layout>
      <div className="space-y-6" data-testid="elearning-activities-page">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-slate-400">
          <span>LMS</span>
          <ChevronRight className="h-3.5 w-3.5" />
          <span className="text-violet-600 font-medium">Bibliothèque d'activités e-learning</span>
        </div>

        <h1 className="text-3xl font-black text-slate-900">Bibliothèque d'activités e-learning</h1>

        {loading ? (
          <div className="space-y-4">
            {[1, 2, 3].map(i => <div key={i} className="h-16 bg-slate-100 rounded-lg animate-pulse" />)}
          </div>
        ) : activities.length === 0 ? (
          <div className="space-y-5">
            <p className="text-slate-500 text-sm">Vous n'avez pas encore d'activités dans votre bibliothèque. Ajoutez-en dès maintenant !</p>
            <div className="bg-slate-50 rounded-xl p-6">
              <Button className="bg-violet-500 hover:bg-violet-600 text-white rounded-lg gap-2" data-testid="btn-create-activity">
                <Plus className="h-4 w-4" />Créer une activité e-learning
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-5">
            <div className="bg-slate-50 rounded-xl p-6">
              <Button className="bg-violet-500 hover:bg-violet-600 text-white rounded-lg gap-2" data-testid="btn-create-activity">
                <Plus className="h-4 w-4" />Créer une activité e-learning
              </Button>
            </div>
            <div className="space-y-3">
              {activities.map(a => (
                <div key={a.id} className="flex items-center gap-4 bg-white border border-slate-200 rounded-xl px-5 py-4 hover:border-violet-200 transition-colors" data-testid={`activity-${a.id}`}>
                  <div className="w-10 h-10 rounded-full bg-violet-100 flex items-center justify-center">
                    <Play className="h-5 w-5 text-violet-500" />
                  </div>
                  <div className="flex-1">
                    <p className="font-semibold text-sm text-slate-900">{a.title}</p>
                    <p className="text-xs text-slate-500">{a.course_title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default ElearningActivitiesPage;
